<template>
  <div>
    <!-- Button to trigger modal -->
    <b-icon size="xl" icon="eye" @click="showModal"> </b-icon>

    <!-- Modal for Quick View -->
    <b-modal
      :title="product.Name"
      id="quickViewModal"
      size="lg"
      hide-footer
      v-model="show"
    >
      <div class="quick-view-content">
        <div class="row">
          <!-- Left Column: Thumbnails + Main Image -->
          <div class="col-md-6 d-flex">
            <!-- Thumbnail Images -->
            <div class="col-md-3 d-flex flex-column">
              <div class="thumbnail-images">
                <img
                  v-for="(thumb, index) in imagesArr"
                  :key="index"
                  :src="thumb"
                  @click="updateMainImage(thumb)"
                  :class="{ active: thumb === selectedImage }"
                  class="img-thumbnail"
                  alt="Product Thumbnail"
                />
              </div>
            </div>

            <!-- Main Image -->
            <div class="col-md-9">
              <div class="main-image">
                <img
                  :src="selectedImage"
                  class="img-fluid"
                  alt="Product Image"
                />
              </div>
            </div>
          </div>

          <!-- Right Column: Product Details -->
          <div class="col-md-6">
            <div class="d-flex align-items-center">
              <h2>{{ product.Name }}</h2>
              <span
                v-if="product.Availability"
                :class="[
                  'badge',
                  product.Availability.toLowerCase().trim() === 'out of stock'
                    ? 'badge-danger'
                    : 'badge-success',
                  'ml-2',
                ]"
              >
                {{ product.Availability }}
              </span>
            </div>

            <div class="d-flex align-items-center">
              <!-- <div class="d-flex align-items-center">
								<span v-for="n in 5" :key="n" class="mr-1">
									<b-icon
										:icon="
											n <= product.avgRating
												? 'star-fill'
												: 'star'
										"
										:style="{
											color:
												n <= product.avgRating
													? '#fd7e14'
													: '#1a1919',
										}"
									></b-icon>
								</span>
								<span class="ml-2"
									>{{ product.totalReviews }} Reviews</span
								>
							</div> -->
              <b-icon-dot class="ml-2" v-if="product.skuNo"></b-icon-dot>
              <p class="mb-0 ml-2" v-if="product.skuNo">
                {{ $t("quickView.skuNo") }} {{ product.skuNo }}
              </p>
            </div>
            <p class="mt-2 brand-info">
              <strong>Price: </strong>
              <span class="mr-1">
                {{ currency.symbol }}
                {{
                  Number(
                    product["Deal Price"]
                      ? product["Deal Price"]
                      : product.Price,
                  ).toFixed(2)
                }}
              </span>
              <del class="" v-if="product['Deal Price']">
                {{ currency.symbol }} {{ Number(product.Price).toFixed(2) }}
              </del>
              <span
                v-if="product['Discount'] || product['Discount(%)']"
                :class="[
                  'badge ml-2',
                  product['Discount'] ? 'badge-danger' : '',
                ]"
              >
                {{ currency.symbol }}
                {{
                  product["Discount"]
                    ? `${product["Discount"]} USD` + " Off"
                    : product["Discount(%)"] + "% Off"
                }}
              </span>
            </p>
            <hr />
            <div class="brand-share d-flex align-items-center">
              <div class="brand-info">
                <!-- <strong v-if="product.Brand">Brand: </strong> -->
                <strong>{{ $t("quickView.brand") }}: </strong>
                {{ product.Brand }}
              </div>
              <!-- <div class="share-icons ml-auto">
								Share item:
								<b-icon icon="facebook" class="mx-1"></b-icon>
								<b-icon icon="twitter" class="mx-1"></b-icon>
								<b-icon icon="instagram" class="mx-1"></b-icon>
							</div> -->
            </div>
            <p class="brand-info">
              <strong>{{ $t("description") }}: </strong
              >{{ product.Description }}
            </p>
            <hr />
            <div
              v-if="
                product.Availability &&
                product.Availability.toLowerCase().trim() === 'out of stock'
              "
            >
              <p class="text-danger font-weight-bold">
                {{ $t("quickView.outOfStock") }}
              </p>
            </div>

            <!-- Checkout Button Centered -->
            <div class="d-flex add-button text-center mt-4" v-else>
              <template
                v-if="$options.components['checkout-increment-decrement']"
              >
                <checkout-increment-decrement
                  :callCheckout="true"
                  :cartItem="product"
                />
              </template>
              <div class="product-icon-circle pointer heart mt-2">
                <b-icon
                  size="xl"
                  icon="heart-fill"
                  @click="removeItem(product)"
                  v-if="wishlistKey"
                ></b-icon>
                <b-icon
                  size="xl"
                  icon="heart"
                  @click="addToWishlist(product)"
                  v-else
                ></b-icon>
              </div>
            </div>
            <hr />
            <div class="product-tags mt-3">
              <strong v-if="product.Category"
                >{{ $t("quickView.category") }}:
              </strong>
              {{ product.Category }} <br />
              <strong v-if="product.tags">{{ $t("quickView.tags") }}: </strong>
              <span
                v-for="(tag, index) in product.tags"
                :key="tag"
                class="tag-badge mr-1"
              >
                {{ tag }}<span v-if="index < product.tags.length - 1">,</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";

export default {
  name: "QuickView",
  props: {
    product: {
      type: Object,
      required: true,
    },
    cartItem: {
      default: () => {},
      type: Object,
    },
    callCheckout: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      imagesArr: [],
      selectedImage: "",
    };
  },
  computed: {
    ...mapGetters({
      getProductData: "product/getProductData",
    }),
    ...mapState({
      cartData: (state) => state.checkout.cartData,
      isLoading: (state) => state.checkout.isLoading,
      totalPrice: (state) => state.checkout.checkoutData.totalPrice,
      listData: (state) => state.wishlist.listData,
      isLoggedin: (state) => state.auth.isLoggedin,
      currency: (state) => state.home.currency,
    }),
    wishlistKey() {
      const data = this.listData;
      const isAvailable = data.some((obj) => obj._id === this.product._id);
      if (isAvailable) {
        return true;
      } else {
        return false;
      }
    },
    productData() {
      return this.getProductData(this.product.slug);
    },
  },
  methods: {
    ...mapActions("checkout", ["clearCart", "fetchCartData"]),
    proceedToCheckout() {
      this.$router.push("/checkout");
    },
    async removeItemFromCart(item) {
      await this.$store.dispatch("checkout/removeItem", {
        cartItem: item,
        callApi: true,
      });
      await this.$store.dispatch("checkout/checkoutFinal");
    },
    showModal() {
      this.show = true;
    },
    updateMainImage(image) {
      this.selectedImage = image;
    },
    async addToWishlist() {
      if (!this.isLoggedin) {
        this.$router.push("/login-with");
      } else {
        await this.$store.dispatch("wishlist/addToWishlist", this.product);
        this.$swal({
          title: this.$t("wishlistProduct.successTitle"),
          text: this.$t("wishlistProduct.addedSuccess"),
          type: "success",
          timer: 1000,
        });
      }
    },
    async removeItem() {
      await this.$store.dispatch("wishlist/removeToWishList", this.product);
      this.$swal({
        group: "item",
        title: this.$t("wishlistProduct.successTitle"),
        text: this.$t("wishlistProduct.removedSuccess"),
        type: "success",
        timer: 1000,
      });
    },
    async getProductDetails() {
      this.isLoading = true;
      try {
        await this.$store.dispatch(
          "product/fetchProductDetails",
          this.product._id,
        );
        this.imagesArr = [];
        for (const i in this.product.images) {
          if (typeof this.product.images[i] == "string") {
            this.imagesArr.push(this.product.images[i]);
          }
        }
        this.isLoading = false;
      } catch (e) {
        console.log(e);
      }
    },
  },
  mounted() {
    this.imagesArr = [];
    for (const i in this.product.images) {
      if (typeof this.product.images[i] == "string") {
        this.imagesArr.push(this.product.images[i]);
      }
    }
    this.selectedImage = this.product?.images?.bigImage;
  },
};
</script>

<style scoped>
.tag-badge {
  white-space: normal;
  word-wrap: break-word;
  display: inline-block;
  /* padding: 0.25em 0.5em; */
  font-size: 1.25rem;
  color: #333;
  /* background-color: #6c757d; Replace with your desired color */
  border-radius: 0.25rem;
  margin-right: 0.5rem;
}

.main-image img {
  width: 100%;
  height: auto;
  border: 2px solid transparent;
  margin-bottom: 10px;
}

.thumbnail-images {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.thumbnail-images img {
  width: 70px;
  height: 70px;
  object-fit: cover;
  cursor: pointer;
  border: 2px solid transparent;
  transition: border-color 0.3s ease;
}

.thumbnail-images img:hover,
.thumbnail-images img.active {
  border-color: #ff8a00;
}

.heart {
  color: #ff6d59;
}
.brand-info {
  font-size: 1.2rem;
  /* font-weight: 500; */
}
.product-tags {
  font-size: 1.2rem;
}
</style>
